/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteAwsKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAwsKmsKeyRequest = {
  /**
   * The ID of the key to delete.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteAwsKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAwsKmsKeySecurity$outboundSchema: z.ZodMiniType<
  DeleteAwsKmsKeySecurity$Outbound,
  DeleteAwsKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAwsKmsKeySecurityToJSON(
  deleteAwsKmsKeySecurity: DeleteAwsKmsKeySecurity,
): string {
  return JSON.stringify(
    DeleteAwsKmsKeySecurity$outboundSchema.parse(deleteAwsKmsKeySecurity),
  );
}

/** @internal */
export type DeleteAwsKmsKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAwsKmsKeyRequest$outboundSchema: z.ZodMiniType<
  DeleteAwsKmsKeyRequest$Outbound,
  DeleteAwsKmsKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteAwsKmsKeyRequestToJSON(
  deleteAwsKmsKeyRequest: DeleteAwsKmsKeyRequest,
): string {
  return JSON.stringify(
    DeleteAwsKmsKeyRequest$outboundSchema.parse(deleteAwsKmsKeyRequest),
  );
}
